const otpIdentityVerificationTemplate = `
<pwr-otp-identity-verification-component 
    options="ctrl.options"
></pwr-otp-identity-verification-component>
`;
export default otpIdentityVerificationTemplate;